import animals from "./animals";
import emotions from "./emotions";
import householdObjects from "./householdObjects";
import textures from "./textures";
import hands from "./hands";

export const SUBJECTS = [animals, householdObjects, emotions, textures, hands];
